var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4Icon24PxPaperclip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 4c2.142 0 3.891 1.684 3.995 3.8L15 8v7.5c0 1.38-1.12 2.5-2.5 2.5-1.325 0-2.41-1.032-2.495-2.336L10 15.5V9.586c0-.552.448-1 1-1 .513 0 .936.386.993.883l.007.117V15.5c0 .276.224.5.5.5.245 0 .45-.177.492-.41L13 15.5V8c0-1.105-.895-2-2-2-1.054 0-1.918.816-1.995 1.85L9 8v7.5c0 1.933 1.567 3.5 3.5 3.5 1.869 0 3.395-1.464 3.495-3.308L16 15.5V11c0-.552.448-1 1-1 .513 0 .936.386.993.883L18 11v4.5c0 3.038-2.462 5.5-5.5 5.5-2.963 0-5.38-2.344-5.496-5.279L7 15.5V8c0-2.21 1.79-4 4-4z",
    transform: "rotate(45 12.5 12.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Icon24PxPaperclip);
export default __webpack_public_path__ + "static/media/4-icon-24-px-paperclip.bef76a5f.svg";
export { ForwardRef as ReactComponent };